import { Component } from '@angular/core';

@Component({
  selector: 'app-coming-soon',
  standalone: true,
  template: `
    <div class="coming-soon">
      <h1>🚧 Coming Soon</h1>
      <p>We're working hard to launch something amazing!</p>
    </div>
  `,
  styles: [`
    .coming-soon {
      min-height: 100vh;
      background: #222;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
    h1 {
      font-size: 3rem;
      margin-bottom: 1rem;
    }
  `]
})
export class ComingSoonComponent {}
